<template>
  <div id="footer">
    <div class="Bottom">
      <div>
        <img src="../assets/img/LOGO-white.png" />
        <div class="Button">0755-27749869</div>
      </div>
      <el-divider direction="vertical"></el-divider>
      <div class="ul">
        <div>关于技森</div>
        <div>公司介绍</div>
        <div>企业文化</div>
      </div>
      <div class="ul">
        <div>产品服务</div>
        <div>产品业务</div>
        <div>公司优势</div>
        <div>公司服务</div>
      </div>
      <div class="ul">
        <div>联系我们</div>
        <div>0755-27749869</div>
        <div>cs@cnjisen.com</div>
        <div>深圳市龙华区龙华街道环智中心C座2405</div>
      </div>
    </div>
    <div class="copyright">
      Copyright©2023 深圳市技森科技有限公司 版权所有 粤ICP备2023095517号
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
.copyright {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #fefefe;
  line-height: 20px;
  letter-spacing: 1px;
  text-align: center;
  border-top: 1px solid #fefefe;
  padding: 19px;
}
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #2e354d;
  overflow: hidden;
}
.Bottom {
  width: 66%;
  margin: auto;
  display: flex;
  padding-top: 120px;
  padding-bottom: 120px;
}
.ul {
  margin-right: 110px;
}
.ul div {
  margin-bottom: 20px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #cecece;
  line-height: 22px;
  white-space: nowrap;
}
.ul div:first-child {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #fefefe;
  line-height: 22px;
}
#footer >>> .el-divider--vertical {
  height: 110px;
  margin-left: 72px;
  margin-right: 72px;
}
.Bottom .Button {
  width: 195px;
  height: 42px;
  background: #2a95fe;
  border-radius: 3px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #fefefe;
  line-height: 42px;
  margin-top: 26px;
  display: flex;
  justify-content: center;
}
.image {
  height: 290px;
  width: 100%;
  background: url(../assets/img/background.png) no-repeat;
  background-size: 100% 100%;
  text-align: center;
}
.heard {
  padding-top: 90px;
  color: #fff;
  font-size: 30px;
  font-weight: bold;
}
.image .Button {
  width: 186px;
  height: 53px;
  background: #fefefe;
  border-radius: 2px;
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #2a95fe;
  line-height: 53px;
  margin: auto;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue